import Connector, {takeQuery} from '../../agent';
import types from './types';
import {entityType} from '../../constants';
import generateJavaSearchQuery from '../../components/Filtering/QueryGenerators/JavaQueryBuilder';
import {getSearchQuery} from './selectors';
import {isPrivateDataField} from "../../utils";

const encode = encodeURIComponent;

const Filter = {
  initializeFiltering: params => {
    return Connector.api.get(
      `/filter/initializeFiltering/${params.entityType}` +
        (params.latestDataViewId ? `?latestDataViewId=${params.latestDataViewId}` : ``) +
        (params.isDeleted
          ? params.latestDataViewId
            ? `&isDeleted=${params.isDeleted}`
            : `?isDeleted=${params.isDeleted}`
          : ``) +
      (params.nonChecked
        ? (params.latestDataViewId || params.isDeleted)
          ? `&nonChecked=${params.nonChecked}`
          : `?nonChecked=${params.nonChecked}`
        : ``)
    );
  },

  getAutoCompleteSuggestionsList: params => {
    return Connector.api.get(
        `/filter/getAutoCompleteSuggestions?inputName=` +
        params.inputName +
        `&inputValue=` +
        encode(params.inputValue)
    ).then(result => {
      result.data.forEach(name => {
        if(params.showPersonalData === false){
          name['privateValue']=name.label;
        }
        name.label = (params.showPersonalData === false && isPrivateDataField(params.inputName))  ? name.label.replace(/[a-z]/g, 'x') : name.label

      });
      return result;
    });
  },
  applyFilter: async params => {
    if (entityType.inventory === params.entityType) {
      return Connector.api.get(
        `/inventoryList/list` + (params.id ? `/${params.id}` : ``) + generateJavaSearchQuery(params)
      );
    } else if (entityType.inventoryAllForExport === params.entityType) {
      return Connector.api.get(
        `/inventoryList/list` + (params.id ? `/${params.id}` : ``) + generateJavaSearchQuery(params)
      );
    } else if (entityType.building === params.entityType) {
      return await Connector.api.get(
        `/buildingSummaryList/list` +
          (params.buildingNum ? `/${params.buildingNum}` : ``) +
          generateJavaSearchQuery(params)
      );
    } else if (entityType.product === params.entityType) {
      return Connector.api.get(`/chemicalProductList/list` + generateJavaSearchQuery(params));
    } else if (entityType.inventoryHist === params.entityType) {
      return Connector.api.get(
        `/inventoryHistList/list` +
          (params.id ? `/${params.id}` : ``) +
          generateJavaSearchQuery(params)
      );
    } else if (entityType.productHist === params.entityType) {
      return Connector.api.get(
        `/chemicalProductHistList/list` +
          (params.id ? `/${params.id}` : ``) +
          generateJavaSearchQuery(params)
      );
    } else if (entityType.batchUpdate === params.entityType) {
      return Connector.api.get(`/inventoryBatchUpdateList/list` + generateJavaSearchQuery(params));
    } else if (entityType.batchUpdateSelected === params.entityType) {
      return Connector.api.get(`/inventoryBatchUpdateList/list` + generateJavaSearchQuery(params));
    } else if (entityType.activity === params.entityType) {
      return Connector.api.get(`/activityList/list` + generateJavaSearchQuery(params));
    }
  }
};

const filterSagas = [
  takeQuery(types.GET_AUTO_COMPLETE_SUGGESTIONS, Filter.getAutoCompleteSuggestionsList),
  takeQuery(types.APPLY_FILTERS_V2, { api: Filter.applyFilter, select: getSearchQuery }),
  takeQuery(types.INITIALIZE_FILTERING, Filter.initializeFiltering)
];

export default filterSagas;
